import { ActionTypes } from '../actions/types';
import { Benutzer } from '../../api';
import { StateModel_Benutzererfassung } from '../store';
import { nameof } from '../../utils/objectUtils';

const initialState: StateModel_Benutzererfassung = {
  id: undefined,
  name: undefined,
  email: undefined,
  password: undefined,
  passwordRepeat: undefined,
  sprache: {},
  benutzerversion: {},
  created: undefined,
  usernameExists: undefined,
  authorized: undefined,
  main: undefined,
  admin: undefined,
  invisibleEinmaladresse: undefined,
  edit: undefined,
  rowsInGrid: undefined,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.RESET_BENUTZERERFASSUNG:
      return {
        ...state,
        id: initialState.id,
        name: initialState.name,
        email: initialState.email,
        password: initialState.password,
        passwordRepeat: initialState.passwordRepeat,
        sprache: initialState.sprache,
        benutzerversion: initialState.benutzerversion,
        created: initialState.created,
        authorized: initialState.authorized,
        main: initialState.main,
        admin: initialState.admin,
        invisibleEinmaladresse: initialState.invisibleEinmaladresse,
        edit: initialState.edit,
        rowsInGrid: initialState.rowsInGrid,
      };
    case ActionTypes.GET_BENUTZER_BY_ID: {
      const benutzer: Benutzer = payload;

      return {
        ...state,
        id: benutzer.id,
        name: benutzer.name,
        email: benutzer.email,
        password: initialState.password,
        passwordRepeat: initialState.passwordRepeat,
        sprache: benutzer.sprache,
        benutzerversion: benutzer.benutzerversion,
        created: benutzer.created,
        authorized: benutzer.hasAuthorized,
        main: benutzer.main,
        admin: benutzer.admin,
        invisibleEinmaladresse: benutzer.invisibleEinmaladresse,
        edit: benutzer.edit,
        rowsInGrid: benutzer.rowsInGrid,
      };
    }
    case ActionTypes.USERNAME_EXISTS: {
      return {
        ...state,
        usernameExists: payload,
      };
    }
    case ActionTypes.SET_BENUTZER: {
      const [value, fieldName] = [payload.value, payload.fieldName];

      switch (fieldName) {
        case nameof<StateModel_Benutzererfassung>('sprache'): {
          return {
            ...state,
            sprache: { ...state.sprache, id: value },
          };
          break;
        }
        case nameof<StateModel_Benutzererfassung>('benutzerversion'): {
          return {
            ...state,
            benutzerversion: { ...state.benutzerversion, id: value },
          };
          break;
        }

        default: {
          return {
            ...state,
            [fieldName]: value,
          };
          break;
        }
      }
      break;
    }
    default:
      return state;
  }
  return state;
}
